import React, { useEffect, useState } from "react";

import { useMutation, useQuery } from "react-query";
import {
  getPolicyPrivacyFn,
  postPolicyPrivacyFn,
} from "../../../Services/PolicyPrivacy";
import { Button } from "@mui/material";
import { toast } from "react-toastify";
import RichTextEditorCustom from "../../../Shared/CustomRichTextEditor";

const PolicyAndPrivecy = () => {
  const [data, setData] = useState("");

  const { data: PrivacyData, refetch } = useQuery(["policy-data"], () =>
    getPolicyPrivacyFn(),
  );

  const { mutate: AddPolicy } = useMutation(postPolicyPrivacyFn, {
    onSuccess: (res) => {
      if (res?.data?.response_code === 200) {
        toast.success(res?.data?.message);
        refetch();
      } else {
        toast.warn(res?.data?.message);
      }
    },
  });

  const Data = PrivacyData?.data?.data?.contain;

  useEffect(() => {
    if (Data) {
      setData(Data);
    }
  }, [Data]);

  return (
    <div className=" flex w-full  flex-col  justify-center  ">
      <p className="text-2xl    font-semibold  text-center  my-5">
        Policy And Privacy
      </p>

      <div className=" w-full text-black  flex items-center justify-center flex-col">
        <RichTextEditorCustom
          value={data}
          onChange={(html) => setData(html)}
          className="!mt-3 !w-full text-no !text-[inherit] "
        />

        <Button
          onClick={() => AddPolicy({ contain: data })}
          className="!my-5"
          variant="outlined"
          color="error"
        >
          Submit
        </Button>
      </div>
    </div>
  );
};

export default PolicyAndPrivecy;
